
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";

interface ClassNameFieldProps {
  form: UseFormReturn<any>;
  courses: Array<{ id: string; name: string; category_id?: string|null; default_capacity?: number; default_duration?: number }>;
  onCourseSelect?: (courseId: string) => void;
}

export const ClassNameField = ({ form, courses, onCourseSelect }: ClassNameFieldProps) => {
  const { t } = useTranslation(['schedule', 'courses']);
  const mode = form.watch('mode');

  // Handle course selection
  const handleCourseSelect = (courseId: string) => {
    // Find the selected course
    const selectedCourse = courses.find(course => course.id === courseId);
    
    if (selectedCourse) {
      // Set the name value
      form.setValue('name', selectedCourse.name);
      
      // If there's a callback for course selection
      if (onCourseSelect) {
        onCourseSelect(courseId);
      }
    }
  };

  return (
    <FormField
      control={form.control}
      name={mode === 'existing' ? 'courseId' : 'name'}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('schedule:class.name', 'Class Name')}</FormLabel>
          {mode === 'existing' ? (
            <Select 
              onValueChange={(value) => {
                field.onChange(value);
                handleCourseSelect(value);
              }} 
              value={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('schedule:class.selectCourse', 'Select a course')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {courses.map((course) => (
                  <SelectItem key={course.id} value={course.id}>
                    {course.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : (
            <FormControl>
              <Input {...field} />
            </FormControl>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
